import * as Msal from "@azure/msal-browser";

const config = {
    auth: {
        clientId: "246a5a88-f394-4565-8b55-3ef75e778ba8",
        authority: "https://login.microsoftonline.com/inra.co.th",
        redirectUri: process.env.NODE_ENV==="production" ? "https://fs.inra.co.th/" : "http://localhost:8080",
    },
    cache: {
        cacheLocation: "localStorage",
    },
};

export const MsalApp = new Msal.PublicClientApplication(config);

const apiScopes = {
    scopes: ['api://246a5a88-f394-4565-8b55-3ef75e778ba8/access_as_user']
}

export class AuthService {

    static signOut() {
        const logoutRequest = {
            // account: this.MsalApp.getAccountByHomeId(vue.$accountId)
            account: AuthService.getAccount()
        }
        MsalApp.logout(logoutRequest)
    }
    
    // async getTokenPopup(request, account) {
    //     request.account = account
    //     return await window.MsalApp.acquireTokenSilent(request).catch(async (error) => {
    //         console.log("silent token acquisition fails.")
    //         if (error instanceof Msal.InteractionRequiredAuthError) {
    //             console.log("acquiring token using popup")
    //             return window.MsalApp.acquireTokenPopup(request).catch(error => {
    //                 console.log(error)
    //             })
    //         } else {
    //             console.log(error)
    //         }
    //     })
    // }
    
    static async getTokenRedirect(request, account) {
        request.account = account
        console.log(request)
        return await MsalApp.acquireTokenSilent(request).catch(async (error) => {
            console.log("silent token acquisition fails")
            if (error instanceof Msal.InteractionRequiredAuthError) {
                console.log("acquiring token using redirect")
                MsalApp.acquireTokenRedirect(request)
            } else {
                console.log(error)
            }
        })
    }
    
    static async getApiAccessTokenRedirect() {
        // var account = this.MsalApp.getAccountByHomeId(vue.$accountId)
        var account = AuthService.getAccount()
        return AuthService.getTokenRedirect(apiScopes, account).catch(error => {
            console.log(error)
        })
    }
    
    static getAccount() {
        return MsalApp.getAccountByHomeId(MsalApp.$accountId)
    }
    
    static async getUserPhoto() {
        var account = AuthService.getAccount();
        var scope = { scopes: ['User.ReadBasic.All'] }
        var endpoint = 'https://graph.microsoft.com/v1.0/me/photo/$value'
        return AuthService.getTokenRedirect(scope, account)
        .then(tokenResponse => {
            var options = {
                headers: {
                    authorization: `Bearer ${tokenResponse.accessToken}`
                }
            }
            return fetch(endpoint, options)
            .then(response => {
                if (!response.ok) {
                    response.json()
                    .then(err => {
                        console.log(err)
                        throw new Error(err.error.message)
                    })
                } else {
                    return response.blob()
                }
            })
            .then(blob => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader()
                    reader.onerror = reject
                    reader.onload = function() {
                        resolve(reader.result)
                    }
                    reader.readAsDataURL(blob)
                })
                .catch(err => {
                    console.log(err)
                    return false
                })
            })
        })
        .catch(err => {
            console.log(err)
            return false
        })
    }
}